import App from "./app.svelte";
import initializeSvelteApp from "common/initializeSvelteApp";

initializeSvelteApp({
  component: App,
  target: ".tc-ticketbuyer-profile-dropdown",
  props: (element) => {
    return {
      abbr: element.getAttribute("data-abbr"),
      menu: JSON.parse(element.getAttribute("data-menu")) ?? [],
      strings: JSON.parse(element.getAttribute("data-strings")),
    };
  },
});
